import { initKineticTemplate } from './kinetic-template';

// Liga o motor partilhado (kinetic-template.ts) ao ciclo de vida do
// WordPress — sem ClientRouter/SPA, cada navegação recarrega a página
// inteira, por isso DOMContentLoaded (dispara uma vez, sempre) é o
// equivalente correto ao astro:page-load da versão Astro
// (astro-kinetic-entry.ts). Sem cleanup: não há "swap" a limpar antes de
// trocar de página — um full reload já destrói tudo (Lenis, ScrollTrigger,
// listeners) sozinho.
document.addEventListener('DOMContentLoaded', initKineticTemplate);
